import { createReducer, on } from '@ngrx/store';
import { ApplicationLoginComplete, SessionReadyAction } from './core.actions';

export interface CoreState {
  loadingInitialData: boolean;
}

export const initialState: CoreState = {
  loadingInitialData: false,
};

export const coreReducer = createReducer(
  initialState,
  on(SessionReadyAction, () => ({ loadingInitialData: true })),
  on(ApplicationLoginComplete, () => ({ loadingInitialData: false })),
);
